import { Experience } from '@/types'
import React, { useState } from 'react'
import { ExperienceMediaDialog } from './experience-media-dialog'
import { Button } from '../ui/button'
import { ImageIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import CroppedCloudinaryImage from './cropped-cloudinary-image'

const ExperienceMedia = ({ experience }: { experience: Experience }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [initialImageIndex, setInitialImageIndex] = useState(0)

  const handleImageClick = (index: number) => {
    setInitialImageIndex(index)
    setIsDialogOpen(true)
  }

  return (
    <>
      <div className="relative mx-auto grid grid-cols-1 md:grid-cols-[2fr_1fr] lg:grid-cols-[2fr_1fr_1fr] md:grid-rows-2 md:grid-flow-col gap-2 h-[240px] md:h-[400px]">
        <div
          onClick={() => handleImageClick(0)}
          className="relative overflow-hidden rounded-md cursor-pointer md:row-span-2"
        >
          <CroppedCloudinaryImage
            fill
            sizes="(max-width: 768px) 100vw, 50vw"
            src={experience.images[0]}
            alt=""
            className="object-cover hover:opacity-90 transition-opacity"
          />
        </div>

        {experience.images[1] ? (
          <div
            onClick={() => handleImageClick(1)}
            className="relative overflow-hidden rounded-md cursor-pointer hidden md:block"
          >
            <CroppedCloudinaryImage
              fill
              sizes="25vw"
              src={experience.images[1]}
              alt=""
              className="object-cover hover:opacity-90 transition-opacity"
            />
          </div>
        ) : null}

        {experience.images[2] ? (
          <div
            onClick={() => handleImageClick(2)}
            className="relative overflow-hidden rounded-md cursor-pointer hidden md:block"
          >
            <CroppedCloudinaryImage
              fill
              sizes="25vw"
              src={experience.images[2]}
              alt=""
              className="object-cover hover:opacity-90 transition-opacity"
            />
          </div>
        ) : null}

        {experience.images[3] ? (
          <div
            onClick={() => handleImageClick(3)}
            className="relative overflow-hidden rounded-md cursor-pointer hidden lg:block"
          >
            <CroppedCloudinaryImage
              fill
              sizes="25vw"
              src={experience.images[3]}
              alt=""
              className="object-cover hover:opacity-90 transition-opacity"
            />
          </div>
        ) : null}

        {experience.images[4] ? (
          <div
            onClick={() => handleImageClick(4)}
            className="relative overflow-hidden rounded-md cursor-pointer hidden lg:block"
          >
            <CroppedCloudinaryImage
              fill
              sizes="25vw"
              src={experience.images[4]}
              alt=""
              className="object-cover hover:opacity-90 transition-opacity"
            />
          </div>
        ) : null}

        <div className="absolute bottom-2 right-2 z-10">
          <Button
            className={cn('border-2 white bg-opacity-50 rounded-full', {
              'bg-white': experience.images.length >= 3,
              'bg-black': experience.images.length < 3,
            })}
            onClick={() => handleImageClick(0)}
          >
            <ImageIcon /> {experience.images.length}
          </Button>
        </div>
      </div>

      <ExperienceMediaDialog
        experience={experience}
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        initialIndex={initialImageIndex}
      />
    </>
  )
}

export default ExperienceMedia
